import { VEXPO_LIVE_STREAM_URL } from 'appenv';

export interface StreamableContent {
  url?: string;
  id?: string;
  type: 'cfStream' | 'direct' | 'zoom' | 'dacast' | 'vExpoLiveStream';
}

export const isVimeoLink = (link) => link?.match(/vimeo\.com\/.+/);
export const isZoomLink = (link) => (link?.includes('zoom') && link?.includes('/j/'));
export const isDacast = (link: string) => link?.includes('iframe.dacast.com');
export const isCloudFlare = (link) => (link?.includes('cloudflare'));
export const isVideo = (link) => !!link?.trim()?.split('.')?.some((it) => it?.match(/(m3u8|mp4)/)?.length);
export const isVexpoLiveStream = (link) => (link?.includes(VEXPO_LIVE_STREAM_URL));
// eslint-disable-next-line no-useless-escape
export const isYoutube = (link) => !!link?.match(/^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w\-]+\?v=|embed\/|v\/)?)([\w\-]+)(\S+)?$/gm)?.length;
export const isSupportedStream = (link) => isZoomLink(link) || isVideo(link) || isYoutube(link) || isCloudFlare(link) || isDacast(link) || isVexpoLiveStream(link) || isVimeoLink(link);

const convertStreamableLink = (link: string): StreamableContent => {
  const trimmedLink = link?.trim();
  if (trimmedLink?.startsWith('http')) {
    if (isCloudFlare(trimmedLink)) {
      return {
        id: trimmedLink,
        type: 'cfStream',
      };
    }
    if (isZoomLink(trimmedLink)) {
      return {
        url: trimmedLink,
        type: 'zoom',
      };
    }
    if (isDacast(trimmedLink)) {
      return {
        url: trimmedLink,
        type: 'dacast',
      };
    }
    if (isVexpoLiveStream(trimmedLink)) {
      return {
        url: trimmedLink,
        type: 'vExpoLiveStream',
      };
    }
    return {
      url: trimmedLink,
      type: 'direct',
    };
  }
  return {
    id: trimmedLink,
    type: 'cfStream',
  };
};

export default convertStreamableLink;
